import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { InputGroup } from '@openng/optimus-ui/inputgroup';
import { InputGroupAddon } from '@openng/optimus-ui/inputgroupaddon';
import { InputText } from '@openng/optimus-ui/inputtext';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface TextProps extends FieldWrapperProps {
  iconPre?: string;
  iconPost?: string;
  type?: string;
}

export interface TextFieldConfig extends FormlyFieldConfig<TextProps> {
  type?: 'text' | Type<TextTypeComponent>;
}

@Component({
  selector: 'lib-formly-text-type',
  templateUrl: './text-type.component.html',
  styleUrl: './text-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslocoDirective,
    NgClass,
    InputGroup,
    InputGroupAddon,
    ReactiveFormsModule,
    InputText,
    FormlyModule
  ]
})
export class TextTypeComponent extends FieldType<FieldTypeConfig<TextProps>> {}
